import { translateColumns } from "../../../../../../utils/tableUtils";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { useTranslation } from "react-i18next";
import {
  AntDesignOutlined,
  CloudSyncOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  LeftOutlined,
  MoreOutlined,
  RightOutlined,
  SendOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Dropdown,
  MenuProps,
  Modal,
  Pagination,
  PaginationProps,
  Popconfirm,
  Space,
  Switch,
  Table,
  TableColumnsType,
  message,
} from "antd";
import React, { FunctionComponent, useState } from "react";
import "./TableSpecializedGroup.scss";
import { get } from "lodash";
import { HelpService } from "../../../../../../service/helper.service";
import { changeActive } from "../../../../../../service/course-plan-managment/specialized-group/specializedGroupApi";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../../../../../config/routes";
import moment from "moment";
type TableData = {
  organization_code: string;
  organization_name: string;
  created_date: string;
  active: boolean;
  status: string;
  users: Array<{
    id: number;
    name: string;
    image_path: string | null;
  }>;
};
type TableSpecializedGroupProps = {
  data?: TableData[];
  totalRecords?: any;
  pageNumber?: number;
  pageSize?: number;
  setPageNumber?: (pageNumber: number) => void;
  setPageSize?: (pageNumber: number) => void;
  searchValue?: string;
  handleFinish?: any;
  setIdDetail?: any;
  setIsOpened?: any;
  setTitleForm?: any;
  setTitleConfirm?: any;
  setCreateOrUpdateText?: any;
  getDetailSpecializedGroupData?: any;
  deleteSpecializedGroup?: any;
};
const TableSpecializedGroup: FunctionComponent<TableSpecializedGroupProps> = ({
  data,
  totalRecords,
  pageSize,
  pageNumber,
  setPageNumber,
  setPageSize,
  searchValue,
  handleFinish,
  setIsOpened,
  setIdDetail,
  setTitleForm,
  setTitleConfirm,
  setCreateOrUpdateText,
  getDetailSpecializedGroupData,
  deleteSpecializedGroup,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const helpService = new HelpService();
  const [totalPage, setTotalPage] = useState(totalRecords);
  const pageNumberProps = pageNumber ?? 10;
  const pageSizeProps = pageSize ?? 1;
  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    if (setPageNumber && setPageSize) {
      setPageNumber(page);
      setPageSize(pageSize);
      setTotalPage(totalRecords);
    }
  };
  const itemRender: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return <LeftOutlined />;
    }
    if (type === "next") {
      return <RightOutlined />;
    }
    return originalElement;
  };
  const options1: MenuProps["items"] = [
    {
      key: "1",
      label: t(t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn"), t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn")),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Quản lý thành viên", "Quản lý thành viên"),
      icon: <SendOutlined />,
    },
    {
      key: "3",
      label: t("Xóa tổ chuyên môn", "Xóa tổ chuyên môn"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];
  const locale = {
    emptyText: (
      <span>
        <p>
          <img
            className="image-empty-data"
            src="/images/empty-img-gray.png"
            alt="empty-img"
          ></img>
        </p>
        <p className="nodata-text">
          {t("Không tìm kết quả với từ khoá", "Không tìm kết quả với từ khoá")} "{searchValue}"
        </p>
      </span>
    ),
    triggerDesc: t("Sắp xếp theo thứ tự Z-A", "Sắp xếp theo thứ tự Z-A"),
    triggerAsc: t("Sắp xếp thứ tự A-Z", "Sắp xếp thứ tự A-Z"),
    cancelSort: t("Huỷ sắp xếp", "Huỷ sắp xếp"),
  };
  const formatDateV2 = (date: string) => {
    return moment(date, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY");
  };

  const newColumns: TableColumnsType<any> = [
    {
      title: "STT",
      key: "numericalOrder",
      width: 2,
      render: (_: any, record: any, index: number) => {
        const orderNumber = (pageNumberProps - 1) * pageSizeProps + index + 1;
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Mã tổ", "Mã tổ"),
      width: "6%",
      dataIndex: "organization_code",
    },
    {
      title: t("Tên tổ chuyên môn", "Tên tổ chuyên môn"),
      width: "25%",
      dataIndex: "organization_name",
      key: "organization_name",
      sorter: {
        compare: (a, b) =>
          a.organization_name.localeCompare(b.organization_name),
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      width: "15%",
      dataIndex: "status",
      render: (_: any, record) => {
        const isNoMember =
          record.status === "Chưa có thành viên" ||
          record.status === t("Chưa có thành viên", "Chưa có thành viên") ||
          record.status === "0";
        const isHasMember =
          record.status === "Đã có thành viên" ||
          record.status === t("Đã có thành viên", "Đã có thành viên") ||
          record.status === "1";
        const statusText = isNoMember
          ? t("Chưa có thành viên", "Chưa có thành viên")
          : isHasMember
          ? t("Đã có thành viên", "Đã có thành viên")
          : record.status;
        return (
          <div className="table-status">
            <div
              className="color-icon"
              style={{
                backgroundColor: isNoMember
                  ? "#D9D9D9"
                  : isHasMember
                  ? "#52C41A"
                  : "white",
              }}
            ></div>
            {statusText}
          </div>
        );
      },
    },

    {
      title: t("Ngày tạo", "Ngày tạo"),
      width: "10%",
      dataIndex: "created_date",
      render: (_: any, record: { created_date: Date }) => {
        return (
          <>
            <span>
              {moment(record?.created_date).format('DD/MM/YYYY')}
            </span>
          </>
        );
      },
    },
    {
      title: t("Thành viên", "Thành viên"),
      dataIndex: "members",
      key: "members",
      width: "15%",
      render: (_: any, record) => {
        const members = record.members;
        if (members.length === 0) {
          return null;
        } else if (members.length === 1) {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                style={{ backgroundColor: "orange", marginRight: "6px" }}
                src={members[0].image_path}
              >
                {members[0].name
                  .split(" ")
                  .map((word: string) => word[0])
                  .join("")}
              </Avatar>
              <span className="avatar-name">{members[0].name}</span>
            </div>
          );
        } else if (members.length === 2 || members.length === 3) {
          return (
            <Avatar.Group
              maxCount={3}
              maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
            >
              {members.map((member: any) => (
                <Avatar
                  key={member.user_id}
                  style={{ backgroundColor: "orange" }}
                  src={member.image_path}
                >
                  {member.name
                    .split(" ")
                    .map((word: string) => word[0])
                    .join("")}
                </Avatar>
              ))}
            </Avatar.Group>
          );
        } else {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar.Group
                maxCount={3}
                maxStyle={{
                  color: "#f56a00",
                  backgroundColor: "#fde3cf",
                  cursor: "pointer",
                }}
              >
                {members.map((member: any) => (
                  <Avatar
                    key={member.user_id}
                    style={{ backgroundColor: "orange" }}
                    src={member.image_path}
                  >
                    {member.name
                      .split(" ")
                      .map((word: string) => word[0])
                      .join("")}
                  </Avatar>
                ))}
              </Avatar.Group>
            </div>
          );
        }
      },
    },

    {
      title: t("Tình trạng", "Tình trạng"),
      dataIndex: "active",
      key: "active",
      render: (_: any, record: { id: number; active: boolean }) => {
        const handleChange = (checked: boolean) => {
          record.active = checked;
        };

        const confirm = (id: number) => {
          changeActive(id.toString(), { active: record.active }).then((res) => {
            console.log(res);
            const statusCode = res.status;

            if (statusCode === 200) {
              message.success(t("Thay đổi trạng thái thành công", "Thay đổi trạng thái thành công"));
              handleFinish();
            }
          });
        };
        const cancel = () => {};
        return (
          <Popconfirm
            description={`${t("Xác nhận đổi tình trạng thành", "Xác nhận đổi tình trạng thành")} ${
              record.active ? t("“Không hoạt động”?", "“Không hoạt động”?") : t("“Hoạt động“?", "“Hoạt động“?")
            }`}
            onConfirm={() => confirm(get(record, "id"))}
            onCancel={cancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            title=""
          >
            <Switch
              defaultChecked={record.active}
              checked={record.active}
              onChange={handleChange}
            />
          </Popconfirm>
        );
      },
      width: "12%",
    },

    {
      title: "",
      width: "5%",
      fixed: "right",
      render: (_, record) => {
        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.detailSpecializedGroup}/${record.id}`,
                    {
                      state: { record, mode: "view" },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>
              <Dropdown
                menu={{
                  items: options1,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      setIdDetail(record.id);
                      setIsOpened(true);
                      setTitleForm(t(t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn"), t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn")));
                      setTitleConfirm(t("Xác nhận Sửa tổ chuyên môn", "Xác nhận Sửa tổ chuyên môn"));
                      setCreateOrUpdateText(t(t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn"), t("Sửa tổ chuyên môn", "Sửa tổ chuyên môn")));
                      getDetailSpecializedGroupData(record.id);
                    }
                    if (key === "2") {
                      navigate(
                        `${routesConfig.detailSpecializedGroup}/${record.id}`,
                        {
                          state: { record, mode: "edit", numberTab: "2" },
                        }
                      );
                    }

                    if (key === "3") {
                      Modal.confirm({
                        title: `${t("Xoá tổ chuyên môn", "Xoá tổ chuyên môn")} ${record.organization_name}`,
                        content: t("Tổ chuyên môn đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá tổ chuyên môn?", "Tổ chuyên môn đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá tổ chuyên môn?"),
                        onOk: () => deleteSpecializedGroup(record),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
    },
  ];
  return (
    <div className="course-plan-managment-table-speialized">
      <div className="table-wrapper">
        <Table
          size="middle"
          tableLayout="auto"
          pagination={false}
          columns={translateColumns(newColumns, t)}
          dataSource={data}
          rowKey={(obj: any) => obj.id}
          scroll={{ x: 1500, y: 600 }}
          locale={locale}
        />
        <Pagination
          total={totalRecords}
          showSizeChanger
          pageSize={pageSize}
          current={pageNumber}
          className="pagination-table"
          onChange={onChange}
          itemRender={itemRender}
          locale={{
            items_per_page: t("/ trang", "/ trang"),
            jump_to: t("Đi đến trang", "Đi đến trang"),
            page: "",
          }}
          showQuickJumper
          showTotal={(total) => `${t("Tổng số", "Tổng số")} ${total} ${t("bản ghi", "bản ghi")}`}
        />
      </div>
    </div>
  );
};

export default TableSpecializedGroup;
